import __isEmpty from 'lodash/isEmpty';
import { itemsExplora, itemsMenuEstatic } from './menuEstatic';

const getTemes = (items, temesDestacats, informatius, temesGenerics, destacatsPortal, podcasts) => {
    const indexTemes = items.item.findIndex((item) => item.id === 'temes');

    if (indexTemes === -1) return items;
    items.item[indexTemes].opcions = {};

    if (!__isEmpty(temesDestacats)) {
        items.item[indexTemes].opcions.destacats = temesDestacats.map((tema) => {
            const slug = tema.url.split('/')[tema.url.split('/').length - 2];
            return {
                titol: 'Avui destaquem',
                tipus: 'destacats',
                type: 'web_actualitat_seccio',
                text: tema.text,
                id: tema.id,
                slug
            };
        });
    }

    if (!__isEmpty(informatius)) {
        items.item[indexTemes].opcions.informatius = informatius.map((informatiu) => {
            const slug = informatiu.url.split('/')[informatiu.url.split('/').length - 2];
            return {
                titol: 'Programes informatius',
                tipus: informatiu.type,
                type: 'web_actualitat_seccio',
                text: informatiu.text,
                id: informatiu.id,
                url: informatiu.url,
                icona: informatiu.icona,
                slug
            };
        });
    }

    if (!__isEmpty(temesGenerics)) {
        items.item[indexTemes].opcions.temesGenerics = temesGenerics.map((tema) => {
            return {
                titol: 'Temes',
                tipus: 'temes',
                type: tema.type,
                text: tema.text,
                id: tema.id,
                slug: tema.slug
            };
        });
    }
    if (!__isEmpty(destacatsPortal)) {
        items.item[indexTemes].opcions.destacatsPortal = destacatsPortal.map((seccio) => {
            return {
                titol: 'Més',
                tipus: 'portal',
                type: seccio.type,
                text: seccio.text,
                id: seccio.id,
                slug: seccio.slug
            };
        });
    }
    if (!__isEmpty(podcasts)) {
        items.item[indexTemes].opcions.podcasts = podcasts.map((podcast) => {
            return {
                titol: 'Pòdcasts',
                tipus: 'podcast',
                type: podcast.type,
                text: podcast.text,
                id: podcast.id,
                slug: podcast.slug
            };
        });
    }

    return items;
};

const getExplora = (items) => {
    const indexExplora = items.item.findIndex((item) => item.id === 'explora' || item.id === 'directes');

    if (!__isEmpty(itemsExplora)) items.item[indexExplora].opcions.explora = itemsExplora;
    items.item[indexExplora].opcions.directes = {
        component: 'DIRECTES',
        id: 'directes'
    };

    return items;
};

const getItemsMenuStatic = (params) => {
    const { temesDestacats, informatius, temesGenerics, destacatsPortal, podcasts } = params;
    let items = itemsMenuEstatic;
    items = getTemes(items, temesDestacats, informatius, temesGenerics, destacatsPortal, podcasts );
    items = getExplora(items);
    return items;
};

const getItemsMenu = (params) => {
    const { tipus } = params;
    if (tipus === 'estatic') {
        return getItemsMenuStatic(params);
    }
    return [];
};

export { getItemsMenu };
